import { Component, Input, OnChanges } from '@angular/core';
import { ReportColumn } from '../../shared/data-table/data-table.component';
import { revenueBreakdownTotal, revenueStatItems, revenueStatusSegments, topItems } from '../../utils/chart-helpers';
import { CHART_COLORS } from '../../utils/chart-theme';
import {
  cooperateDisplayName,
  cooperateProfileImage,
  driverDisplayName,
  driverProfileImage,
  fmtMoney,
  parseDriverRevenueKpis,
  parseRevenueKpis
} from '../../utils/kpi-helpers';

@Component({
  selector: 'app-br-revenue-tab',
  templateUrl: './revenue-tab.component.html'
})
export class BrRevenueTabComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() error: string;
  @Input() data: any;

  readonly primaryColor = CHART_COLORS[0];
  moneyFormatter = fmtMoney;

  statItems: any[] = [];
  statusSegments: any[] = [];
  revenueTotal = 0;
  fundingRevenueItems: any[] = [];
  driverRevenueItems: any[] = [];
  completedRevenueItems: any[] = [];
  fundingRows: any[] = [];
  driverRows: any[] = [];

  fundingColumns: ReportColumn[] = [
    {
      key: 'name',
      header: 'Funding Source',
      type: 'avatar',
      avatarName: (row) => cooperateDisplayName(row),
      avatarImage: (row) => cooperateProfileImage(row),
      avatarVariant: 'cooperate'
    },
    { key: 'total', header: 'Revenue', value: true, render: (row) => fmtMoney(row.total) },
    { key: 'totalCompletedJobs', header: 'Completed', value: true, render: (row) => fmtMoney(row.totalCompletedJobs) },
    { key: 'totalCancelledJobs', header: 'Cancelled', value: true, render: (row) => fmtMoney(row.totalCancelledJobs) },
    { key: 'totalRemainingJobs', header: 'Remaining', value: true, render: (row) => fmtMoney(row.totalRemainingJobs) }
  ];

  driverColumns: ReportColumn[] = [
    {
      key: 'name',
      header: 'Driver',
      type: 'avatar',
      avatarName: (row) => driverDisplayName(row._id),
      avatarImage: (row) => driverProfileImage(row),
      avatarVariant: 'driver'
    },
    { key: 'total', header: 'Revenue', value: true, render: (row) => fmtMoney(row.total) },
    { key: 'totalCompletedJobs', header: 'Completed', value: true, render: (row) => fmtMoney(row.totalCompletedJobs) },
    { key: 'totalCancelChargeJobs', header: 'Cancel Charge', value: true, render: (row) => fmtMoney(row.totalCancelChargeJobs) },
    { key: 'totalCadJobs', header: 'No-show / CAD', value: true, render: (row) => fmtMoney(row.totalCadJobs) },
    { key: 'totalRemainingJobs', header: 'Remaining', value: true, render: (row) => fmtMoney(row.totalRemainingJobs) }
  ];

  ngOnChanges() {
    if (!this.data) return;

    const { summary: fundingSummary, sources: fundingSources } = parseRevenueKpis(this.data.revenueKpis);
    const { sources: driverSources } = parseDriverRevenueKpis(this.data.driverRevenueKpis);
    const kpiCards = this.data.kpiCards || {};

    const cards = {
      total: kpiCards.total != null ? kpiCards.total : fundingSummary.total,
      totalCadJobs: kpiCards.totalCadJobs != null ? kpiCards.totalCadJobs : fundingSummary.totalCadJobs,
      totalCancelledJobs: kpiCards.totalCancelledJobs != null ? kpiCards.totalCancelledJobs : fundingSummary.totalCancelledJobs,
      totalCompletedJobs: kpiCards.totalCompletedJobs != null ? kpiCards.totalCompletedJobs : fundingSummary.totalCompletedJobs,
      totalRemainingJobs: kpiCards.totalRemainingJobs != null ? kpiCards.totalRemainingJobs : fundingSummary.totalRemainingJobs
    };

    this.fundingRows = fundingSources;
    this.driverRows = driverSources;

    this.statItems = revenueStatItems(cards);
    this.statusSegments = revenueStatusSegments(cards);
    this.revenueTotal = revenueBreakdownTotal(cards);
    this.fundingRevenueItems = topItems(this.fundingRows.map((row) => ({ label: cooperateDisplayName(row), value: Number(row.total) || 0 })));
    this.driverRevenueItems = topItems(
      (this.data.charts && this.data.charts.topDriversByRevenue)
      || this.driverRows.map((row) => ({ label: driverDisplayName(row._id), value: Number(row.totalCompletedJobs) || 0 }))
    );
    this.completedRevenueItems = topItems(this.fundingRows.map((row) => ({ label: cooperateDisplayName(row), value: Number(row.totalCompletedJobs) || 0 })));
  }
}
